var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let adsBlockedPromise;
/**
 *  @internal Used to guess if the user uses an ad blocker.
 *
 *  (!) This will make a (HEAD) call to google's ad services,
 *  without cors, credentials (cookies) and referrer.
 */
export default function adsBlocked() {
    return __awaiter(this, void 0, void 0, function* () {
        if (adsBlockedPromise) {
            return yield adsBlockedPromise;
        }
        if (!window || !window.fetch) {
            return true;
        }
        adsBlockedPromise = window.fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
            method: 'HEAD',
            mode: 'no-cors',
            credentials: 'omit',
            referrerPolicy: 'no-referrer',
            cache: 'no-store',
        })
            .then(() => false)
            .catch(() => true);
        return yield adsBlockedPromise;
    });
}
//# sourceMappingURL=adsBlocked.js.map